import { render, staticRenderFns } from "./ReporteClose.vue?vue&type=template&id=58a3a112&scoped=true"
import script from "./ReporteClose.vue?vue&type=script&lang=js"
export * from "./ReporteClose.vue?vue&type=script&lang=js"
import style0 from "./ReporteClose.vue?vue&type=style&index=0&id=58a3a112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a3a112",
  null
  
)

export default component.exports